import React from "react";

const ErrorPage = () => {
  return (
    <div className="flex w-screen h-screen justify-center items-center">
      <h1 className="text-5xl">404 Not Found</h1>
    </div>
  );
};

export default ErrorPage;
